import { Component, Input } from '@angular/core';
import { NDCRegistrationCard } from 'src/app/model/card/ndc-registration-card';

@Component({
  selector: 'app-ndc-registration-card',
  templateUrl: './ndc-registration-card.component.html',
  styleUrls: ['./ndc-registration-card.component.scss']
})
export class NdcRegistrationCardComponent {
  @Input() ndcRegistrationCards: NDCRegistrationCard[] = [];
  ndcNoteSectionData: Boolean = false;
  salesHubCategory: any;
  constructor() {}
}
